import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './current-invitations.styles'
import CurrentTable from './current-table/current-table.container'
import CurrentSkeleton from './current-skeleton/current-skeleton'
import mountains from './mountains.png'
import { Link } from 'react-router-dom'
import ArrowIcon from 'react-icons/lib/fa/caret-right'
import { Pagination } from 'pobble-components/dist/pagination'

class CurrentInvitations extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const {
      classes,
      pending,
      noInvitations,
      pagination,
      onPageChange
    } = this.props
    let invitations = noInvitations ? (
      <div>
        <img src={mountains} className={classes.illustration} alt="Not Found" />
        <p className={classes.container}>
          You don't have any invitations yet.
          <br /> We'll email when you do.
        </p>
      </div>
    ) : pending ? (
      <CurrentSkeleton />
    ) : (
      <div>
        <CurrentTable />
        <div className={classes.pagination}>
          <Pagination onPageChange={onPageChange} data={pagination} />
        </div>
      </div>
    )
    return (
      <div>
        {invitations}
        <div className={classes.archived}>
          <Link className={classes.link} to={'/invitations/archived'}>
            Archived invitations <ArrowIcon />
          </Link>
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(CurrentInvitations)
